import {  animate, timeline as timeline3, stagger, Delegate as Delegate2, animate as animate5, timeline as timeline7, inView as inView6, animate as animate6 } from "//au.sciconsports.com/cdn/shop/t/10/assets/vendor.min.js?v=52426788336887041471791789384";
import { MobileNavigationDrawer } from "//au.sciconsports.com/cdn/shop/t/10/assets/custom-theme.js?v=31982837702531113891791790142";
import { cachedFetch, imageLoaded as imageLoaded2 } from "//au.sciconsports.com/cdn/shop/t/10/assets/theme.js?v=85133811737309182421791790139";

var CustomNavigationDrawer = class extends MobileNavigationDrawer {
	constructor() {
		super();

		const delegate = new Delegate2(this);
		delegate.on("click", "button[data-panel]", this._onPanelButtonClick.bind(this));
		this._isTransitioning = false;
		this.addEventListener("dialog:after-hide", () => {
			this.reinitializeDrawer();
		});
	}

	get openFrom() {
		return window.matchMedia("(max-width: 699px)").matches ? this.getAttribute("mobile-opening") : super.openFrom;
	}

	// Used for navigation mobile and navigation desktop set to drawer
	switchToPanel(panelIndex, linkListIndex = null) {
		const panels = this.querySelectorAll(".panel");
		let panelToHideTransform, panelToShowTransform, panelToHide = linkListIndex !== null ? panels[parseInt(panelIndex) - 1] : panels[parseInt(panelIndex) + 1], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper"), timelineSequence = [];

		if (document.dir === "rtl") {
			panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(100%)"] : ["translateX(0%)", "translateX(-100%)"];
			panelToShowTransform = linkListIndex !== null ? ["translateX(-100%)", "translateX(0%)"] : ["translateX(100%)", "translateX(0%)"];
		} else {
			panelToHideTransform = linkListIndex !== null ? ["translateX(0%)", "translateX(-100%)"] : ["translateX(0%)", "translateX(100%)"];
			panelToShowTransform = linkListIndex !== null ? ["translateX(100%)", "translateX(0%)"] : ["translateX(-100%)", "translateX(0%)"];
		}

		timelineSequence.push(
			[panelToHide, { transform: panelToHideTransform, opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.3, opacity: { at: "+0.3" }, transform: { at: "+0.3" } }],
			"panelHidden",
			[panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"], transform: panelToShowTransform }, { at: "<", transform: { duration: 0.3 } }]
		);

		if (linkListIndex !== null) {
			timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
		}

		timeline3(timelineSequence);
	}

	// Used when mega menu is set to drawer
	showPanel(panelIndex, linkListIndex = null) {
		const panels = this.querySelectorAll(".panel");
		let timelineSequence = [], panelToShow = panels[panelIndex], linkLists = panelToShow.querySelectorAll(".panel__wrapper");

		if (!panelToShow.hasAttribute("open") && !this._isTransitioning) {
			this._isTransitioning = true;
			timelineSequence.push(
				[this, { width: [this.offsetWidth + "px", (this.offsetWidth - parseInt(window.getComputedStyle(this).getPropertyValue("padding"))) * 2 + "px"] }, { duration: 0.2 }],
				[panelToShow, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { at: "<" }]
			);
			timelineSequence.push(this.switchLinkList(linkLists, linkListIndex));
		}

		if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
			timelineSequence.push([linkLists[this.previousLinkIndex], { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.2 }]);
		}

		timeline3(timelineSequence).finished.then(() => {
			if (this.previousLinkIndex && this.previousLinkIndex !== linkListIndex) {
				linkLists[this.previousLinkIndex].removeAttribute("style");
			}

			if (panelToShow.hasAttribute("open") && this.previousLinkIndex !== linkListIndex) {
				timeline3([this.switchLinkList(linkLists, linkListIndex)]);
			}

			this.previousLinkIndex = linkListIndex;
			panelToShow.setAttribute("open", "");
			this._isTransitioning = false;
		});
	}

	switchLinkList(linkLists, linkListIndex) {
		Array.from(linkLists).forEach((item) => {
			item.setAttribute("hidden", "");
		});
		linkLists[linkListIndex].removeAttribute("hidden");
		return [linkLists[linkListIndex].querySelectorAll("li"), { opacity: [0, 1], visibility: ["hidden", "visible"], transform: ["translateY(-10px)", "translateY(0)"] }, { easing: "ease", duration: 0.2, at: "-0.15", delay: stagger(0.025, { start: 0.1 }) }];
	}

	// Set navigation drawer to initial state when drawer closed
	reinitializeDrawer() {
		if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
			this.style.removeProperty("width");
			this.setExpanded();
		} else {
			const firstPanel = this.querySelector(".panel:first-child");
			firstPanel.style.opacity = "1";
			firstPanel.style.visibility = "visible";
			firstPanel.style.transform = "translateX(0%)";
		}

		Array.from(this.querySelectorAll(".panel:not(:first-child)")).forEach((item) => {
			if (this.hasAttribute("mega-menu")) {
				item.removeAttribute("open");
			}
			item.style.opacity = "0";
			item.style.visibility = "hidden";
			Array.from(item.querySelectorAll(".panel__wrapper")).forEach((list) => list.setAttribute("hidden", ""));
		});
	}

	setExpanded(target) {
		Array.from(this.querySelectorAll("button[data-panel]")).forEach((item) => {
			item.setAttribute("aria-expanded", "false");
		});

		if (target) {
			target.setAttribute("aria-expanded", "true");
		}
	}

	_onPanelButtonClick(event, target) {
		if (this.hasAttribute("mega-menu") && window.matchMedia("(min-width:1150px)").matches) {
			this.setExpanded(target);
			this.showPanel(...target.getAttribute("data-panel").split("-"));
		} else {
			this.switchToPanel(...target.getAttribute("data-panel").split("-"));
		}
	}
};
if (!window.customElements.get("custom-navigation-drawer")) {
	window.customElements.define("custom-navigation-drawer", CustomNavigationDrawer);
}


var ToggleFooterAccordion = class extends HTMLButtonElement {
	connectedCallback() {
		this.addEventListener("click", this.toggleSubmenuHandler.bind(this));

		const resizeObserver = new ResizeObserver((entries) => {
			if (entries[0].target == this) {
				if (window.innerWidth < 700) {
					this.previousElementSibling.setAttribute("aria-hidden", "true");
					this.setAttribute("aria-hidden", "false");
				} else {
					this.previousElementSibling.setAttribute("aria-hidden", "false");
					this.setAttribute("aria-hidden", "true");
				}
			}
		});

		resizeObserver.observe(this);
	}

	toggleSubmenuHandler() {
		const expanded = this.getAttribute("aria-expanded");
		if (expanded === "true") {
			this.setAttribute("aria-expanded", "false");
		} else {
      this.setAttribute("aria-expanded", "true");
		}
	}
};
if (!window.customElements.get("toggle-footer-accordion")) {
	window.customElements.define("toggle-footer-accordion", ToggleFooterAccordion, { extends: "button" });
}


var GoToTopButton = class extends HTMLButtonElement {
	connectedCallback() {
		this.addEventListener("click", () => {
			window.scrollTo({
                top: 0,
                left: 0,
                behavior: "smooth"
            });
		});
	}
};
if (!window.customElements.get("go-to-top-button")) {
	window.customElements.define("go-to-top-button", GoToTopButton, { extends: "button" });
}



var OpenAnimatedSubmenu = class extends HTMLButtonElement {
	connectedCallback() {
		this.addEventListener("click", () => {
			const megaMenuContent = this.closest(".mega-menu-content");
			const megaMenuWrapper = this.closest(".mega-menu-wrapper");
			const submenuContainer = this.closest('.animated-submenu');
			const submenuIsOpen = submenuContainer.classList.contains("show-animated-submenu");
			const megaMenuContentInnerHeight = megaMenuContent.getBoundingClientRect().height - 60; // height - padding
			const megaMenuWrapperWidth = megaMenuWrapper.getBoundingClientRect().width;
			const submenu = this.nextElementSibling;
			const submenuRect = submenu ? submenu.getBoundingClientRect() : {height: 0, width: 0};

			if (!submenuIsOpen && submenuRect.width >= megaMenuWrapperWidth) {
				megaMenuWrapper.style.width = (submenuRect.width) + 'px';
				submenuContainer.style.width = (submenuRect.width) + 'px';
			} else if (!submenuIsOpen && submenuRect.width < megaMenuWrapperWidth) {
				megaMenuWrapper.style.width = (megaMenuWrapperWidth) + 'px';
				submenuContainer.style.width = (megaMenuWrapperWidth) + 'px';
			}

			if (!submenuIsOpen && submenuRect.height > megaMenuContentInnerHeight) {
				megaMenuContent.style.height = (submenuRect.height + 60) + 'px';
			} else if (!submenuIsOpen && submenuRect.height < megaMenuContentInnerHeight) {
				submenu.style.height = megaMenuContentInnerHeight + 'px';
			}

			if (submenuIsOpen) {
				megaMenuContent.style.height = '';
				megaMenuWrapper.style.width = '';
				submenuContainer.style.width = '';
			}

			submenuContainer.classList.toggle("show-animated-submenu");
		});
	}
};
if (!window.customElements.get("open-animated-submenu")) {
	window.customElements.define("open-animated-submenu",  OpenAnimatedSubmenu, { extends: "button" });
}


var CloseAnimatedSubmenu = class extends HTMLButtonElement {
	connectedCallback() {
		this.addEventListener("click", () => {
			const megaMenuContent = this.closest(".mega-menu-content");
			const megaMenuWrapper = this.closest(".mega-menu-wrapper");
			const submenuContainer = this.closest('.animated-submenu');
			const submenuIsOpen = submenuContainer.classList.contains("show-animated-submenu");

			if (submenuIsOpen) {
				megaMenuContent.style.height = '';
				megaMenuWrapper.style.width = '';
				submenuContainer.style.width = '';
			}

			submenuContainer.classList.toggle("show-animated-submenu");
		});
	}
};
if (!window.customElements.get("close-animated-submenu")) {
	window.customElements.define("close-animated-submenu", CloseAnimatedSubmenu, { extends: "button" });
}


var LoginDropDown = class extends HTMLElement {
	constructor() {
        super();
		this.loginDropdownSection = document.querySelector('.shopify-section--login-dropdown');
		if (this.loginDropdownSection) {
			this.insertAdjacentElement('beforeend', this.loginDropdownSection.querySelector('#custom-login-wrapper'));
			this.loginDropdownSection.remove();
		}

		this.loginWrapper = this.querySelector('#custom-login-wrapper');
		this.togglePanelButton = this.querySelector("#toggle-login-panel");
		this.overlay = document.getElementById('login-dropdown__overlay');
		this.scrollArea = this.querySelector('#login-dropdown__scroll-area');
		this.createAccountBtn = this.querySelector('#create-account-btn');
		this.loginBtn = this.querySelector('#login-btn');
		this.goToRecoverLink = this.querySelector('#recover-link');
		this.goToLoginLink = this.querySelector('#go-to-login-link');
		this.recoverBlock = this.querySelector('#custom_recover');
		this.submitRicoverFormButton = this.recoverBlock && this.recoverBlock.querySelector('[type="submit"]');

		this.submitRicoveryFormListener = this.submitRicoveryForm.bind(this);
		this.toggleDropdownListener = this.toggleDropdown.bind(this);
		this.closeDropdownListener = this.closeDropdown.bind(this);
    }

	connectedCallback() {
		if (!this.togglePanelButton || !this.loginBtn || !this.createAccountBtn || !this.goToRecoverLink || !this.goToLoginLink || !this.overlay || !this.submitRicoverFormButton) return;

		this.createAccountBtn.setAttribute('href', this.getAttribute('register-url'));

		this.togglePanelButton.addEventListener('click', this.toggleDropdownListener);
		this.overlay.addEventListener('click', this.closeDropdownListener);

		this.loginBtn.setAttribute('href', this.getAttribute('register-url'));

		this.goToRecoverLink.addEventListener('click', () => {
			const scrollStep = window.innerWidth >= 700 ? 384 : 272;
			animate(this.scrollArea, { transform: [`translateX(-${scrollStep}px)`, `translateX(-${scrollStep * 2}px)`] }, { duration: 0.15, easing: "ease" });
		});

		this.goToLoginLink.addEventListener('click', () => {
			const scrollStep = window.innerWidth >= 700 ? 384 : 272;
			animate(this.scrollArea, { transform: [`translateX(-${scrollStep * 2}px)`, `translateX(-${scrollStep}px)`] }, { duration: 0.15, easing: "ease" });
		});

		this.submitRicoverFormButton.addEventListener('click', this.submitRicoveryFormListener);

		Array.from(document.querySelectorAll('.header-link')).map(link => link.addEventListener('click', this.closeDropdownListener));
	}

	async submitRicoveryForm(event) {
		event.preventDefault();
		this.submitRicoverFormButton.setAttribute("aria-busy", "true");
		const form = this.recoverBlock.querySelector('form');
		const formData = new FormData(form);

		const response = await fetch(`${Shopify.routes.root}account/recover`, {
			method: "POST",
			body: formData
		});

		if (response.ok) {
			form.classList.add("form-success");
			form.classList.remove("form-error");
			form.classList.add("form-success");
		} else {
			form.classList.remove("form-success");
			form.classList.add("form-error");
		}

		this.submitRicoverFormButton.removeAttribute("aria-busy");
	}

	toggleDropdown() {
		if (this.loginWrapper.classList.contains('hidden')) {
			this.openDropdown()
		} else {
			this.closeDropdown();
		}
	}

	openDropdown() {
		this.loginWrapper.style.visibility = "hidden";
		this.loginWrapper.classList.remove('hidden');
		this.togglePanelButton.setAttribute('aria-expanded', 'true');
		animate(this.loginWrapper, { opacity: [0, 1], visibility: ["hidden", "visible"] }, { duration: 0.5, easing: "ease" });
		document.documentElement.classList.add('lock');
	}

	closeDropdown() {
		animate(this.loginWrapper, { opacity: [1, 0], visibility: ["visible", "hidden"] }, { duration: 0.5, easing: "ease" });
		this.togglePanelButton.setAttribute('aria-expanded', 'false');

		setTimeout(() => {
			this.loginWrapper.classList.add('hidden');
			animate(this.scrollArea, { transform: `translateX(0)` }, { duration: 0.15, easing: "ease" });
		}, 470);

		document.documentElement.classList.remove('lock');

		const form = this.recoverBlock.querySelector('form');
		form.classList.remove('form-success');
		form.classList.remove('form-error');
	}
};
if (!window.customElements.get("login-dropdown")) {
	window.customElements.define("login-dropdown", LoginDropDown);
}

/**
 * First tap works like hover event and second tap works like click event
 */
var TapHoverTapClick = class extends HTMLAnchorElement {
	constructor () {
		super();

		this.countClick = 1;
		this.url = this.getAttribute('href') ? this.getAttribute('href') : this.getAttribute('data-href');
		this.hoveredElementClass = this.getAttribute('data-hovered-element') || null;
		this.hoveredElement = this.hoveredElementClass ? this.closest(this.hoveredElementClass) : null;
		this.tapBreakpoint = this.getAttribute('data-tap-breakpoint') ? parseInt(this.getAttribute('data-tap-breakpoint')) : null;

		if (this.hoveredElement) {
			this.hoveredElement.countClick = 1;
		}
	}

	connectedCallback() {
		return false;
		if ('ontouchstart' in window) {
			this.addEventListener('touchstart', (e) => {
				e.preventDefault();

				if (this.tapBreakpoint && window.innerWidth < this.tapBreakpoint) {
					this.setLocationHref();
					return;
				}

				if (this.countClick > 2) {
					if (this.hoveredElement) {
						this.hoveredElement.classList.remove('hovered');
						this.hoveredElement.countClick = 1;
					} else {
						this.classList.remove('hovered');
					}
					this.countClick = 1;
				}

				if (this.countClick === 1 || (this.hoveredElement && this.hoveredElement.countClick === 1)) {
					if (this.hoveredElement) {
						if (this.hoveredElementClass == '.product-card') {
							const rect = this.hoveredElement.getBoundingClientRect();
							this.hoveredElement.style.height = rect.height + 'px';
						}
						this.hoveredElement.classList.add('hovered');
					} else {
						this.classList.add('hovered');
					}
				}

				if (this.countClick === 2 || (this.hoveredElement && this.hoveredElement.countClick === 2)) {
					this.setLocationHref();
				}

				this.countClick += 1;
				if (this.hoveredElement) {
					this.hoveredElement.countClick += 1;
				}
			});

			screen.orientation.addEventListener('change', function() {
				this.countClick = 1;

				if (this.hoveredElement) {
					this.hoveredElement.classList.remove('hovered');
					this.hoveredElement.countClick = 1;
					this.hoveredElement.style.height = '';
				} else {
					this.classList.remove('hovered');
				}
			}.bind(this));
		}
	}

	setLocationHref() {
		if (this.url) {
			window.location.href = this.url;
		} else {
			if (this.hoveredElement) {
				this.hoveredElement.classList.remove('hovered');
			} else {
				this.classList.remove('hovered');
			}
		}
	}
};
if (!window.customElements.get("tap-hover-tap-click")) {
	window.customElements.define("tap-hover-tap-click", TapHoverTapClick, {extends: 'a'});
}



/* Collection / Search */
var ShowMorefiltersButton = class extends HTMLButtonElement {
	constructor() {
		super();

		this.toggleHandler = this._toggleHandler.bind(this);
	}

	connectedCallback() {
		this.removeEventListener("click", this.toggleHandler);
		this.addEventListener("click", this.toggleHandler);
	}

	_toggleHandler() {
		const filterValues = this.previousElementSibling.children;
		if (!filterValues.length) return;

		const totalHidden = Array.from(filterValues).filter(item => item.classList.contains('hidden'));
		const totalVisible = Array.from(filterValues).filter(item => item.classList.contains('visible'));

		if (totalHidden.length) {
			totalHidden.forEach(item => {
				item.classList.remove('hidden');
				item.classList.add('visible');
				this.classList.add('less');
				const label = this.getAttribute('data-label-less');
				this.firstElementChild.textContent = label;
			});
		}

		if (totalVisible.length) {
			totalVisible.forEach(item => {
				item.classList.remove('visible');
				item.classList.add('hidden');
				this.classList.remove('less');
				const label = this.getAttribute('data-label-more');
				this.firstElementChild.textContent = label;
			});
		}
	}
};
if (!window.customElements.get("show-more-filters-button")) {
	window.customElements.define("show-more-filters-button", ShowMorefiltersButton, { extends: "button" });
}



/* Collection / Search */
var TogglefiltersButton = class extends HTMLButtonElement {
	connectedCallback() {
		const collectionTopBar = document.getElementById("collection__top-bar");
		const topBarIsOpen = window.localStorage.getItem('collectionTopBarIsOpen');

		if (topBarIsOpen && topBarIsOpen === 'true') {
			this.classList.add('active');
			if (collectionTopBar) {
				collectionTopBar.classList.add('open');
				this.setButtonText(true);
			}
		}

		this.addEventListener("click", () => {
			this.classList.toggle('active');
			if (collectionTopBar) {
				collectionTopBar.classList.toggle('open');
			}

			this.setButtonText(this.classList.contains('active'));

			window.localStorage.setItem('collectionTopBarIsOpen', this.classList.contains('active'));
		});
	}

	setButtonText(filtersBarIsOpen = false) {
		if (filtersBarIsOpen) {
            this.lastElementChild.textContent = this.getAttribute('data-label-hide');
        } else {
            this.lastElementChild.textContent = this.getAttribute('data-label-show');
		}
	}
};
if (!window.customElements.get("toggle-filters-button")) {
	window.customElements.define("toggle-filters-button", TogglefiltersButton, { extends: "button" });
}



var MobileSortByButton = class extends HTMLButtonElement {
	connectedCallback() {
		this.addEventListener("click", () => {
			if (window.innerWidth > 1000) return false;

			const areaControls = this.getAttribute('aria-controls');
			const popover = document.getElementById(areaControls);
			const options = popover.querySelectorAll('[role="option"]');

			for (var i = 0; i < options.length; i++) {
				options[i].addEventListener("click", (event) => {
					const url = new URL(location.href);
					const sectionId = document.querySelector(".product-list-section").id.replace("shopify-section-", "");

					url.searchParams.set("sort_by", event.currentTarget.value);
					url.searchParams.set("section_id", sectionId);
					url.searchParams.delete("page");

					this.dispatchEvent(new CustomEvent("facet:update", {
						bubbles: true,
						detail: {
						  url
						}
					}));
				});
			}
		});
	}
}
if (!window.customElements.get("mobile-sort-by-button")) {
	window.customElements.define("mobile-sort-by-button", MobileSortByButton, { extends: "button" });
}


class ToggleVariationExpanded extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener("click", this.toggleExpanded.bind(this));
  }

  toggleExpanded() {
    const container = this.closest('.variant-picker__option-values');
    if(container) {
      const hiddenElements = container.querySelectorAll('.hidden');
      hiddenElements.forEach(element => {
        element.classList.toggle('visible');
      });
    }

    this.classList.toggle('open');
  }
}
if (!window.customElements.get("collapse-button")) {
  window.customElements.define("collapse-button", ToggleVariationExpanded, { extends: "button" });
}


/** Search page / Product Color Variation */
var ReinitRegionsDiscountData = {
	setRegionsDiscountData: (productCard, productColorVariation) => {
		if (!productCard && !productColorVariation) return;

		ReinitRegionsDiscountData.getRegionsDiscountData(productCard.getAttribute('data-product-id'), productColorVariation).then(data => {
			if (data) {
				ReinitRegionsDiscountData.fillRegionsDiscountData(data, productCard);
			}
		});
	},

	getRegionsDiscountData: async (productId, productColorVariation) => {
		if (!productId && !productColorVariation) return;

		let collectionIds = productColorVariation.getAttribute('data-collection-ids');
		collectionIds = collectionIds.includes(',') ? collectionIds.split(',') : [collectionIds];

		const {salePrice, regularPrice, description, badge} = await window.RegiosDOPP.api.v0.calculateDiscountedPrices({
			productId: productId,
			variantId: productColorVariation.getAttribute('data-product-id'),
			regularPriceInCents: Number(productColorVariation.getAttribute('data-price')),
			collectionIds: collectionIds || [], // If your discount is based on collections, provide this
		});

		return {salePrice, regularPrice, description, badge, handle: productColorVariation.getAttribute('handle')};
	},

	fillRegionsDiscountData: (data, productCard) => {
		const {salePrice, regularPrice, description, badge} = data;
		const discountAmount = regularPrice.amount - salePrice.amount;
		if (discountAmount === 0) return;

		const priceListElement = productCard.getElementsByClassName('price-list');
		if (!priceListElement) return;

		const salePriceElement = priceListElement[0].getElementsByTagName('sale-price');

		salePriceElement[0].innerText = salePrice.formatted;
		priceListElement[0].insertAdjacentHTML('beforeend', `<compare-at-price class="text-subdued line-through visible" data-discounted-price="${regularPrice.formatted}" data-created-by-regios-dopp="true" style="text-decoration: line-through;">${regularPrice.formatted}</compare-at-price>`);

		if (description && description.html) {
			priceListElement[0].insertAdjacentHTML('beforeend', `<div class="regios-dopp-description visible" style="display: block;">${description.html}</div>`);
		}

		if (badge && badge.html) {
			productCard.insertAdjacentHTML('beforeend', `<div class="product-card__badge-list visible"><on-sale-badge class="badge badge--on-sale visible" discount-mode="saving">${badge.html}</on-sale-badge></div>`);
		}
	}
};


/* Collection / Search */
var LoadMoreButton = class extends HTMLButtonElement {
	constructor() {
        super();
		this.section = document.querySelector('.product-list-section');
		this.animationElement = this.querySelector('.button__loader');
		this.isSearchPage = !!this.closest('.shopify-section--main-search') || false;
	}

	connectedCallback() {
		this.sectionId = this.section.id.replace('shopify-section-', '');
		this.addEventListener("click", this.loadNextPage.bind(this));

		/*
		 *  In case of a page refresh we create promises to retrieve the previous products
		 */
		if (window.performance.getEntriesByType('navigation') && window.location.href.includes('page=')) {
			const performance = window.performance.getEntriesByType('navigation')[0].type;

			if (performance === 'reload') {
				this.reloadPage();
				//this.createPromises();
			}
		}
	}

	setSearchPageRegionsDiscountData(responseProductListContent) {
		const responseProductCards = this.getNewProductCards(responseProductListContent);
		const responseProductCardTotal = responseProductCards.length;
		const productListElement = document.getElementsByTagName('product-list')[0];
		const promises = [];

		for (let index = 0; index < responseProductCardTotal; index++) {
			const responseProductCard = responseProductCards[index];
			promises.push(new Promise(async (resolve, reject) => {
				resolve(await ReinitRegionsDiscountData.getRegionsDiscountData(responseProductCard.getAttribute('data-product-id'), responseProductCard))
			}));
		}

		Promise.all(promises).then((result) => {
			if (result) {
				for (let index = 0; index < result.length; index++) {
					const data = result[index];

					for (let i = 0; i < responseProductCardTotal; i++) {
						const responseProductHandle = responseProductCards[i].getAttribute('handle');
						if (responseProductHandle == data.handle) {
							const productCard = productListElement.querySelector(`.product-card[handle="${responseProductHandle}"]`);

							ReinitRegionsDiscountData.fillRegionsDiscountData(data, productCard);
						}
					}
				}
			}
		});
	}

	getNewProductCards(productListContent) {
		return productListContent.getElementsByClassName('product-card');
	}

	getRegiosObject(productListContent) {
		if (!productListContent) return [];

		const productCards = this.getNewProductCards(productListContent);
		const productCardTotal = productCards.length;
		const newProducts = [];

		for (let index = 0; index < productCardTotal; index++) {
			const productCard = productCards[index];
			let tags = productCard.getAttribute('data-tags');
			if (tags.length) {
				tags = tags.includes(',') ? tags.split(',') : [tags];
			}

			newProducts.push({
				'productId': productCard.getAttribute('data-product-id'),
                'regularPriceInCents': Number(productCard.getAttribute('data-price')),
                'handle': productCard.getAttribute('handle'),
				'vendor': productCard.getAttribute('data-vendor'),
                'url': productCard.getAttribute('data-url'),
                'tags': tags || []
			});
		}

		return newProducts;
	}

	dispatchRegiosEvent(productListContent) {
		if (!productListContent) return;

		window.dispatchEvent(new CustomEvent("regios-dopp:collection-page:new-items", {
			detail: {
				newItems: this.getRegiosObject(productListContent)
			}
		}));
	}

	async loadNextPage() {
		const nextUrl = this.getAttribute('data-next-url');
		if (!nextUrl) return false;

		const locationHref = new URL(window.location.href);
		const fetchUrl = new URL(nextUrl, locationHref.origin);
		fetchUrl.searchParams.set('section_id', this.sectionId);
		locationHref.searchParams.set('page', fetchUrl.searchParams.get('page'));
		window.history.replaceState({}, '', locationHref.toString());

		this.setAttribute('aria-busy', 'true');
		this.animateButton();
		this.section.classList.add('is-loading');

		try {
			const responseContent = new DOMParser().parseFromString(await (await cachedFetch(fetchUrl.href)).text(), "text/html");
			const productListContent = responseContent.getElementsByTagName('product-list')[0].innerHTML;
			const loadMoreBtn = responseContent.getElementById('listing__load-more-button');
			const loadMoreBtnNextUrl = loadMoreBtn.getAttribute('data-next-url');
			const productListElement = document.getElementsByTagName('product-list')[0];

			productListElement.insertAdjacentHTML('beforeend', productListContent);
			this.setAttribute('aria-label', loadMoreBtn.getAttribute('aria-label'));

			if (loadMoreBtnNextUrl) {
				this.setAttribute('data-next-url', loadMoreBtnNextUrl);
			} else {
				this.disabled = true;
			}

			if (this.isSearchPage) {
				this.setSearchPageRegionsDiscountData(responseContent.getElementsByTagName('product-list')[0]);
			} else {
				this.dispatchRegiosEvent(responseContent.getElementsByTagName('product-list')[0]);
			}

	    } catch (error) {
            console.error(error);
		}

		this.setAttribute('aria-busy', 'false');
		this.section.classList.remove('is-loading');
		this.animateButton(false);
	}

	animateButton(start = true) {
		if (start) {
			timeline3([
				[this.animationElement.previousElementSibling, { opacity: [1, 0]}, { duration: 0.1 }],
				[this.animationElement, { transform: ["translateY(10px)", "translateY(0)"], opacity: 1 }, { duration: 0.15 }]
			]);
			animate(this.animationElement.children, { opacity: [1, 0.1] }, { duration: 0.35, delay: stagger(0.35 / 3), direction: "alternate", repeat: Infinity });
		} else {
			timeline3([
				[this.animationElement, { transform: ["translateY(0)", "translateY(-10px)"], opacity: 0 }, { duration: 0.15 }],
				[this.animationElement.previousElementSibling, { opacity: [0, 1]}, { duration: 0.1 }]
			]);
		}
	}

	createPromises() {
		const locationHref = new URL(window.location.href);
		let currentPage = locationHref.searchParams.get('page');

		if (currentPage) {
			const promises = [];
			locationHref.searchParams.set('section_id', this.sectionId);
			currentPage = Number(currentPage);

			for (let index = currentPage - 1; index > 0; index--) {
				locationHref.searchParams.set('page', index);

				promises.push(new Promise(async (resolve, reject) => {
					resolve(new DOMParser().parseFromString(await (await cachedFetch(locationHref.href)).text(), "text/html"))
				}))
			}

			this.execPromises(promises);
		}
	}

	async execPromises(promises) {
		const result = await promises.reduce(async (acc, currentPromise) => {
			const results = await acc;

			return [...results, await currentPromise]
		}, Promise.resolve([]));

		const productListElement = document.getElementsByTagName('product-list')[0];

		for (let index = 0; index < result.length; index++) {
			const responseContent = result[index];
			const productListContent = responseContent.getElementsByTagName('product-list')[0].innerHTML;
			if (index > 0) {
				productListElement.insertAdjacentHTML('afterbegin', productListContent);
			}
			this.dispatchRegiosEvent(responseContent.getElementsByTagName('product-list')[0]);
		}
	}

	reloadPage() {
		const locationHref = new URL(window.location.href);
		locationHref.searchParams.delete('page')
		window.history.replaceState({}, '', locationHref.toString());
		if (window.history.scrollRestoration) {
			window.history.scrollRestoration = 'manual';
		}
		window.location.reload();
	}
}
if (!window.customElements.get("load-more-button")) {
	window.customElements.define("load-more-button", LoadMoreButton, { extends: "button" });
}


/* Collection / Search - Product Card */
var ProductColorVariations = class extends HTMLDivElement {
	constructor() {
		super();
        this.loadColorVariationData = this.loadColorVariationDataHandler.bind(this);
	}

	connectedCallback() {
		this.colorSwatches = Array.from(this.querySelectorAll('.thumbnail-swatch'));

		if (!this.colorSwatches.length) return;

		for (let index = 0; index < this.colorSwatches.length; index++) {
			this.colorSwatches[index].addEventListener('click', this.loadColorVariationData)
		}
	}

	setRegionsDiscountData(productCard, productColorVariation) {
		if (!productCard && !productColorVariation) return;

		this.getRegionsDiscountData(productCard.getAttribute('data-product-id'), productColorVariation).then(data => {
			if (data) {
				const {salePrice, regularPrice, description, badge} = data;
				const discountAmount = regularPrice.amount - salePrice.amount;
				if (discountAmount === 0) return;

				const priceListElement = productCard.getElementsByClassName('price-list');
				if (!priceListElement) return;

				const salePriceElement = priceListElement[0].getElementsByTagName('sale-price');

				salePriceElement[0].innerText = salePrice.formatted;
				priceListElement[0].insertAdjacentHTML('beforeend', `<compare-at-price class="text-subdued line-through visible" data-discounted-price="${regularPrice.formatted}" data-created-by-regios-dopp="true" style="text-decoration: line-through;">${regularPrice.formatted}</compare-at-price>`);

				if (description && description.html) {
					priceListElement[0].insertAdjacentHTML('beforeend', `<div class="regios-dopp-description visible" style="display: block;">${description.html}</div>`);
				}

				if (badge && badge.html) {
					productCard.insertAdjacentHTML('beforeend', `<div class="product-card__badge-list visible"><on-sale-badge class="badge badge--on-sale visible" discount-mode="saving">${badge.html}</on-sale-badge></div>`);
				}
			}
		});
	}

	async getRegionsDiscountData(productId, productColorVariation) {
		if (!productId && !productColorVariation) return;

		let collectionIds = productColorVariation.getAttribute('data-collection-ids');
		collectionIds = collectionIds.includes(',') ? collectionIds.split(',') : [collectionIds];

		const {salePrice, regularPrice, description, badge} = await window.RegiosDOPP.api.v0.calculateDiscountedPrices({
			productId: productId,
			variantId: productColorVariation.getAttribute('data-product-id'),
			regularPriceInCents: Number(productColorVariation.getAttribute('data-price')),
			collectionIds: collectionIds || [], // If your discount is based on collections, provide this
		});

		return {salePrice, regularPrice, description, badge};
	}

	async loadColorVariationDataHandler(e) {
		e.preventDefault();
		const target = e.currentTarget;
		const href = target.href;
		const locationHref = new URL(window.location.href);
		const fetchUrl = new URL(href, locationHref.origin);
		fetchUrl.searchParams.set('section_id', 'custom-product-card');

		try {
			const productCard = target.closest('.product-card');
			const selectedSize = productCard.querySelector('.variations-container.size .block-swatch.is-selected')?.closest('.variant')?.getAttribute('data-value');
			const responseContent = new DOMParser().parseFromString(await (await cachedFetch(fetchUrl.href)).text(), "text/html");
			const responseProductCard = responseContent.querySelector(".product-card");
			if (!responseProductCard) return;
			productCard.replaceChildren(...document.importNode(responseProductCard, true).childNodes);
			ReinitRegionsDiscountData.setRegionsDiscountData(productCard, responseProductCard);

			productCard.setAttribute('handle', responseProductCard.getAttribute('handle'));
			productCard.setAttribute('data-product-id', responseProductCard.getAttribute('data-product-id'));
			productCard.setAttribute('data-price', responseProductCard.getAttribute('data-price'));
			productCard.setAttribute('data-vendor', responseProductCard.getAttribute('data-vendor'));
			productCard.setAttribute('url', responseProductCard.getAttribute('url'));
			productCard.setAttribute('tags', responseProductCard.getAttribute('tags'));
			productCard.setAttribute('data-collection-ids', responseProductCard.getAttribute('data-collection-ids'));
			productCard.setAttribute('class', responseProductCard.getAttribute('class'));

			if (selectedSize) {
				this.restoreSizeSelection(productCard, selectedSize);
			}

		} catch (error) {
			console.error(error);
		}
	}

	restoreSizeSelection(productCard, value) {
		const variant = productCard.querySelector(`.variations-container.size .variant[data-value="${value}"]`);
		if (!variant) return;

		productCard.querySelectorAll('.variations-container.size .block-swatch').forEach((swatch) => swatch.classList.remove('is-selected'));
		variant.querySelector('.block-swatch')?.classList.add('is-selected');

		const variantId = variant.getAttribute('data-variant-id');
		const variantIdInput = productCard.querySelector('form')?.querySelector('input[name="id"]');
		if (variantIdInput) {
			variantIdInput.value = variantId;
		}

		const imgAnchor = productCard.querySelector('.product-card__figure a');
		if (imgAnchor) {
			const anchorUrl = new URL(imgAnchor.href, window.location.origin);
			anchorUrl.searchParams.set('variant', variantId);
			imgAnchor.href = anchorUrl;
		}
	}
};
if (!window.customElements.get("product-color-variations")) {
	window.customElements.define("product-color-variations", ProductColorVariations, { extends: "div" });
}


/* Collection / Search - Product Card */
var ProductSizeVariants = class extends HTMLDivElement {
	constructor() {
		super();
        this.setFormData = this.setFormDataHandler.bind(this);
	}

	connectedCallback() {
		this.sizeSwatches = Array.from(this.querySelectorAll('.block-swatch '));

		if (!this.sizeSwatches.length) return;

		for (let index = 0; index < this.sizeSwatches.length; index++) {
			this.sizeSwatches[index].addEventListener('click', this.setFormData)
		}
	}

	setFormDataHandler(e) {
		e.preventDefault();
		const target = e.currentTarget;
		const wrapper = target.closest('div');
		const variantId = wrapper.getAttribute('data-variant-id');
		const productCard = target.closest('.product-card');
		const showMoreLink = productCard.querySelector('.variants-show-more__link');
		const colorsLink = productCard.querySelector('[is="go-to-product-page"]');
		const imgAnchor = productCard.querySelector('.product-card__figure a');
		const locationHref = new URL(window.location.href);
		const newAnchorUrl = new URL(imgAnchor, locationHref.origin);

		newAnchorUrl.searchParams.set('variant', variantId);
		if (imgAnchor) {
			imgAnchor.href = newAnchorUrl;
		}
		if (showMoreLink) {
			showMoreLink.href = newAnchorUrl;
		}
		if (colorsLink) {
			colorsLink.href = newAnchorUrl;
		}

		for (let index = 0; index < this.sizeSwatches.length; index++) {
			if (target !== this.sizeSwatches[index]) {
				this.sizeSwatches[index].classList.remove('is-selected');
			} else {
				if (!target.classList.contains('is-selected')) {
					this.sizeSwatches[index].classList.add('is-selected');
				}
			}
		}

		const form = wrapper.closest('.product-card__info')?.querySelector('form');
		const variantIdInput = form?.querySelector('input[name="id"]');
		if (variantIdInput) {
			variantIdInput.value = target.classList.contains('is-selected') ? variantId : '';
		}
	}
};
if (!window.customElements.get("product-size-variants")) {
	window.customElements.define("product-size-variants", ProductSizeVariants, { extends: "div" });
}


/* Collection / Search - Product Card */
var GoToProductPageLink = class extends HTMLAnchorElement {
	connectedCallback() {
        this.addEventListener('click', this.goToProductPage.bind(this));
	}

	goToProductPage(e) {
		e.preventDefault();
		const target = e.currentTarget;
		const productCardInfo = target.closest('.product-card__info');
		let selectedSizeVariant = productCardInfo && productCardInfo.querySelector('.block-swatch.is-selected');
		let selectedColorVariant = productCardInfo && productCardInfo.querySelector('.thumbnail-swatch.is-selected');

		if (selectedSizeVariant) {
			const locationHref = new URL(window.location.href);
			const newUrl = new URL(target.href, locationHref.origin);
			newUrl.searchParams.set('variant', selectedSizeVariant.parentElement.getAttribute('data-variant-id'));
			window.location.href = newUrl.href;
		}

		if (selectedColorVariant || (!selectedSizeVariant && !selectedColorVariant)) {
			window.location.href = target.href;
		}
	}
};
if (!window.customElements.get("go-to-product-page")) {
	window.customElements.define("go-to-product-page", GoToProductPageLink, { extends: "a" });
}



/* Collection */
var ProductListPromoBanner = class extends HTMLDivElement {
	connectedCallback() {
		const firstProductCards = document.getElementsByClassName('product-card');
		if (!firstProductCards) return;

		const resizeObserver = new ResizeObserver((entries) => {
			const entry = entries[0];
			if (entry.contentBoxSize) {
				const entryHeight = entry.target.getBoundingClientRect().height;

				this.style.height = entryHeight + 'px';
				//firstProductCards[firstProductCards.length - 1].style.height = entryHeight + 'px';
			}
		});

		resizeObserver.observe(firstProductCards[0]);
	}
};
if (!window.customElements.get("product-list-promo-banner")) {
	window.customElements.define("product-list-promo-banner", ProductListPromoBanner, { extends: "div" });
}



var ToggleMediaWithTextAccordion = class extends HTMLButtonElement {
  connectedCallback() {
    this.addEventListener("click", this.toggleAccordionHandler.bind(this));
  }

  toggleAccordionHandler() {
    const expanded = this.getAttribute("aria-expanded");
    const areaControls = this.getAttribute("area-controls");

    if (expanded === "true") {
      // If it is already expanded, do nothing
      return;
    }

    const contentLeft = document.getElementById("contentLeft");
    const contentRight = document.getElementById("contentRight");

    contentLeft.classList.remove("show");
    contentRight.classList.remove("show");

    const buttons = document.querySelectorAll('button[aria-expanded="true"]');
    buttons.forEach(button => button.setAttribute("aria-expanded", "false"));

    // Toggle aria-expanded div
    if (areaControls === "contentLeft") {
      contentLeft.classList.add("show");
    } else if (areaControls === "contentRight") {
      contentRight.classList.add("show");
    }
    this.setAttribute("aria-expanded", "true");
  }
};

if (!window.customElements.get("toggle-media-with-text-accordion")) {
  window.customElements.define("toggle-media-with-text-accordion", ToggleMediaWithTextAccordion, { extends: "button" });
}



/* Product card hover */
var SetProductCardHeightOnHover = class extends HTMLDivElement {
	connectedCallback() {
		this.addEventListener("mouseenter", function() {
			if ('ontouchstart' in window) return;
			const parent = this.parentElement;
			parent.style.height = parent.getBoundingClientRect().height + 'px';
			parent.classList.add('hovered');
		}.bind(this));

		this.addEventListener("mouseleave", function() {
			const parent = this.parentElement;
			parent.classList.remove('hovered');
			parent.style.height = '';
		}.bind(this));
	}
};
if (!window.customElements.get("product-card-hover")) {
	window.customElements.define("product-card-hover", SetProductCardHeightOnHover, { extends: "div" });
}



/* Show / Hide Password */
var TogglePassword = class extends HTMLButtonElement {
	connectedCallback() {
		this.addEventListener('click', function(e) {
			e.preventDefault();
			const isShown = this.classList.contains('shown');
			const hideLabel = this.getAttribute('data-hide-label');
			const showLabel = this.getAttribute('data-show-label');
			const srOnly = this.firstElementChild;
			const passwordInput = this.closest('.password-control').querySelector('input');

			if (isShown) {
				this.classList.remove('shown');
				passwordInput.setAttribute('type', 'password');
			} else {
				this.classList.add('shown');
				passwordInput.setAttribute('type', 'text');
			}

			srOnly.textContent = isShown? showLabel : hideLabel;
		}.bind(this));
	}
};
if (!window.customElements.get("toggle-password")) {
	window.customElements.define("toggle-password", TogglePassword, { extends: "button" });
}



var reduceMotion = window.matchMedia("(prefers-reduced-motion: no-preference)").matches;
var CustomMediaWithText = class extends HTMLElement {
  connectedCallback() {
    if (reduceMotion) {
      const items = this.querySelectorAll(".media-with-text__item");
      if (items.length > 0) {
        items.forEach((item) => {
          inView6(item, (observer) => this.reveal(observer.target));
        });
      }
    }
  }
  reveal(item) {
    const media = item.querySelector(".media-with-text__media");

    if (media) {
      imageLoaded2(media.querySelector("img")).then(() => {
        timeline7([
          [media, { opacity: [0, 1] }, { duration: 0.3 }],
          [media.querySelector("img, video-media"), { transform: ["scale(1.05)", "scale(1)"] }, { duration: 0.3, at: "<" }]
        ]);
      });
      animate5(item.querySelector(".media-with-text__content > .prose"), { opacity: [0, 1] }, { duration: 0.2, delay: 0.3 });
    }
  }
};
if (!window.customElements.get("custom-media-with-text-pdp")) {
  window.customElements.define("custom-media-with-text-pdp", CustomMediaWithText);
}



/* Multi Before/After Images: Navigation */
var MultiBeforeAfterImageNavigation = class extends HTMLDivElement {
	constructor(){
		super();
		this.navButtons = this.querySelectorAll('.before-after__thumb');
		this.beforeAfterImages = this.nextElementSibling.querySelectorAll('.before-after');
		this.showBeforeAfterImageHandler = this.showBeforeAfterImage.bind(this);
	}

	connectedCallback() {
		for (let index = 0; index < this.navButtons.length; index++) {
			const button = this.navButtons[index];
			button.addEventListener('click', this.showBeforeAfterImageHandler);
		}
	}

	showBeforeAfterImage(e) {
		const target = e.currentTarget;
		const beforeAfterImageId = target.getAttribute('area-controls');

		for (let index = 0; index < this.navButtons.length; index++) {
			const button = this.navButtons[index];
			if (target === button) {
				button.classList.add('active');
				button.setAttribute('aria-expanded', 'true');
			} else {
				button.classList.remove('active');
				button.setAttribute('aria-expanded', 'false');
            }
		}

		for (let index = 0; index < this.beforeAfterImages.length; index++) {
			const image = this.beforeAfterImages[index];
			if (image.id === beforeAfterImageId) {
				image.classList.add('active');
			} else {
				image.classList.remove('active');
			}
		}
	}
};
if (!window.customElements.get("multi-before-after-image__navigation")) {
	window.customElements.define("multi-before-after-image__navigation", MultiBeforeAfterImageNavigation, { extends: "div" });
}



/* Multi Before/After Images: Split Cursor */
var CustomSplitCursor = class extends HTMLElement {
	connectedCallback() {
		this._parentSection = this.closest(".before-after");
		this._dragging = false;
		this._offsetX = this._currentX = 0;
		this._parentSection.addEventListener("pointerdown", this._onPointerDown.bind(this));
		this._parentSection.addEventListener("pointermove", this._onPointerMove.bind(this));
		this._parentSection.addEventListener("pointerup", this._onPointerUp.bind(this));
		this._recalculateOffset();
		window.addEventListener("resize", this._recalculateOffset.bind(this));
	}

	get minOffset() {
		return -this.offsetLeft - (document.dir === "rtl" ? this.clientWidth : 0);
	}

	get maxOffset() {
		return this.offsetParent.clientWidth + this.minOffset;
	}

	_onPointerDown(event) {
		if (event.target === this || this.contains(event.target)) {
			this._initialX = event.clientX - this._offsetX;
			this._dragging = true;
		}
	}

	_onPointerMove(event) {
		if (!this._dragging) {
			return;
		}
		this._currentX = Math.min(Math.max(event.clientX - this._initialX, this.minOffset), this.maxOffset);
		this._offsetX = this._currentX;
		this._parentSection.style.setProperty("--clip-path-offset", `${this._currentX.toFixed(1)}px`);
	}

	_onPointerUp() {
		this._dragging = false;
	}

	_recalculateOffset() {
		this._parentSection.style.setProperty("--clip-path-offset", `${Math.min(Math.max(this.minOffset, this._currentX.toFixed(1)), this.maxOffset)}px`);
	}
};
if (!window.customElements.get("custom-split-cursor")) {
	window.customElements.define("custom-split-cursor", CustomSplitCursor);
}



var OrbeLocalizationSelector = class extends HTMLDivElement {
	constructor(){
		super();
		this.orbeLocSelectorElement = document.getElementById('md-footer-selector-block');
	}

	connectedCallback() {
		if (!this.orbeLocSelectorElement) return;

		const orbeLocSelectorClone = this.orbeLocSelectorElement.cloneNode(true);
		this.append(orbeLocSelectorClone);
		this.orbeLocSelectorElement.remove();
	}
};
if (!window.customElements.get("orbe-localization-selector")) {
	window.customElements.define("orbe-localization-selector", OrbeLocalizationSelector, { extends: "div" });
}


/* Fill size guide page content into drawer */
var SizeGuideOpener = class extends HTMLButtonElement {
	constructor(){
        super();
		this.sizeGuideDrawerElement = document.getElementsByClassName('drawer__size-guide')
		this.sizeGuideDrawerProseElement = this.sizeGuideDrawerElement ? this.sizeGuideDrawerElement[0].getElementsByClassName('prose') : null;
		this.localization = this.getAttribute('data-localization');
	}

    connectedCallback() {
        if (!this.sizeGuideDrawerProseElement) return;
		this.sizeGuideDrawerProseElement[0].classList.add('multi-column-image-with-video');
		this.loadSizeData();
		this.setOpenAnchorObserver();
	}

	async loadSizeData() {
		const href = `${this.localization}/pages/size-guide`;
		const locationHref = new URL(window.location.href);
		const fetchUrl = new URL(href, locationHref.origin);

		try {
			const responseContent = new DOMParser().parseFromString(await (await cachedFetch(fetchUrl.href)).text(), "text/html");
			this.sizeGuideDrawerProseElement[0].replaceChildren(...document.importNode(responseContent.querySelector(".size-guide-container"), true).childNodes);
		} catch (error) {
			console.error(error);
		}
	}

	setOpenAnchorObserver() {
		const observer = new MutationObserver((mutations) => {
			if (document.getElementsByClassName('size-guide')) {
				observer.disconnect();
				const anchorOpenSizeGuide = document.getElementsByClassName('size-guide');
				const buttonOpener = document.getElementsByClassName('size-guide__open-button');
				if (!anchorOpenSizeGuide && !buttonOpener) return;

				for (let index = 0; index < anchorOpenSizeGuide.length; index++) {
					anchorOpenSizeGuide[index].addEventListener('click', (e) => {
						e.preventDefault();
						buttonOpener[0].click();
					});
				}
			}
		});

		observer.observe(document.getElementsByClassName('product-info')[0], { childList: true });
	}
};
if (!window.customElements.get("size-guide-opener")) {
	window.customElements.define("size-guide-opener", SizeGuideOpener, { extends: "button" });
}


/* Collection description: read more & read less */
var ToggleCollectionDescriptionReadMore = class extends HTMLButtonElement {
	constructor(){
        super();
		this.descriptionContainer = document.getElementById('collection-description__container')
	}

    connectedCallback() {
        if (!this.descriptionContainer) return;
		if (this.descriptionContainer.scrollHeight > this.descriptionContainer.clientHeight) {
			this.classList.add('visible');
		}

		this.addEventListener('click', (e) => {
			const target = e.currentTarget;

			if (target.classList.contains('active')) {
				this.descriptionContainer.classList.add('ellipsis');
				target.firstElementChild.innerText = target.getAttribute('data-readmore');
				target.classList.remove('active');
				animate6(this.descriptionContainer, {height: `20px`}, {duration: 0.15, easing: "ease"});
				window.setTimeout(() => {
					this.descriptionContainer.style.height = '';
				}, 200);
			} else {
				this.descriptionContainer.classList.remove('ellipsis');
				target.firstElementChild.innerText = target.getAttribute('data-readless');
				target.classList.add('active');
				animate6(this.descriptionContainer, {height: `${this.descriptionContainer.getBoundingClientRect().height}px`}, {duration: 0.15, easing: "ease"});
				window.setTimeout(() => {
					this.descriptionContainer.style.height = '';
				}, 200);
			}
        });
	}
};
if (!window.customElements.get("toggle-readmore-button")) {
	window.customElements.define("toggle-readmore-button", ToggleCollectionDescriptionReadMore, { extends: "button" });
}
